<template>

	<div class="yuyuelie" style="min-height: 100%; ">
		<div class="content" >
			<div class="header ">
				<div class="container-fluid" >
					<div class="row" style="padding-bottom: 20px">
						<div class="col-sm-6 fix" style="padding: 0"></div>

						<div class="col-sm-6" style="padding: 0">
							<div style="width:270px;float: right">
								<div class="form-group  has-feedback" style="margin-bottom: 0;">
									<input type="text" placeholder="请输入姓名、电话搜索" v-model="cha" class="form-control" v-on:input="jiansuo" style="border-radius: 15px" aria-describedby="inputSuccess2Status">
									<span class="glyphicon  glyphicon-search form-control-feedback" aria-hidden="true"></span>
								</div>
								<div style="width:270px;float: right;z-index:2000;position: absolute;">
									<ul id="suosuok" class="box">
										<li v-for="info in ul_list" @click="searchinfo(info.user_id,info.baobao_name)" class="clearfloat">
											<span class="dam">{{info.baobao_name}}</span>
											<span class="dam">{{info.baobao_name2}}</span>
										</li>
									</ul>
								</div>

							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-sm-12" id="infobox" style="padding: 0" v-if="list">
							<table class="table table-bordered table-hover" style="margin-bottom: 0;" >
								<thead style="background:#f1f1f1">
								<tr>
									<th>序号</th>
									<th>类型</th>
									<th>家长姓名</th>
									<th>会员姓名</th>
									<th>别名</th>
									<th>性别</th>
									<th>生日</th>
									<th>月龄</th>
									<th>课时</th>
									<th>测评次数</th>
									<th></th>
								</tr>
								</thead>
								<tbody>
								<tr v-for="(fe,index) in list">
									<td>{{index+1}}</td>
									<td>{{fe.hy_zt}}</td>
									<td>{{fe.jz_name}}</td>
									<td >{{fe.baobao_name}} </td>
									<td>{{fe.baobao_name2}}</td>
									<td>{{fe.baobao_sex}}</td>
									<td>{{fe.baobao_birthday}}</td>
									<td>{{fe.yueling}}</td>
									<td>{{fe.y_keshi}}</td>
									<td>{{fe.cp_num}}</td>
									<td style="color:#ff797c;cursor: pointer" @click="motai(fe.user_id)" >预约测评</td>
								</tr>
								<tr>
									<td v-if="list==''" colspan="11">请先在右上角进行搜索</td>
								</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<!-- 模态框（Modal） -->
			<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
				<div class="modal-dialog" style="width: 400px;margin: 0 auto">
					<div class="modal-content">
						<div class="modal-header">
							<button type="button" class="close" data-dismiss="modal" aria-hidden="true">X</button>
						</div>
						<div class="modal-body">
							<div class="block">
								<span class="demonstration">预约测评时间:</span>
								<el-date-picker v-model="cp_time" type="date" id="question" size="mini" placeholder="选择日期" @change="trigger1" :picker-options="pickerOptions0">
								</el-date-picker>
							</div>
							<div class="block" style="margin-top:15px">
								<span class="demonstration">请选择测评师:</span>
								<el-select v-model="teacher" size="mini" placeholder="请选择" @change="trigger1">
									<el-option
											v-for="item in cp_teachers"
											:key="item.user_id"
											:label="item.username"
											:value="item.user_id">
									</el-option>
								</el-select>
							</div>
							<div class="block" style="margin-top:15px">
								<p>上午</p>
								<span
										v-for="(item,index) in catalogs1"
										class="chosetime"
										:class="[item.select == catalogSelect ? 'active':'',item.state == false ? 'hui':'']"
										@click="click_time(item.select,item.state)">
                            	{{item.timeName}}</span>
								<p>下午</p>
								<span
										v-for="(item,index) in catalogs2"
										class="chosetime"
										:class="[item.select == catalogSelect ? 'active':'',item.state == false ? 'hui':'']"
										@click="click_time(item.select,item.state)">
                            	{{item.timeName}}</span>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-primary" @click="yuyue" v-if="cp_time && teacher">预约</button>
							<button type="button" class="btn btn-primary" disabled  v-if="!cp_time || !teacher">预约</button>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>



</template>

<script>
	//每次隐藏时，清除数据。确保点击时，重新加载
    $("#myModal").on("hidden.bs.modal", function() {
        $(this).removeData("bs.modal");
    });
	export default{
		data(){
			return{
				centre_id:'',
				token:'',
	            create_user:'',
	            list:[],
	            cha:'',
	            ul_list:'',
	            cp_time:'',
	            user_id:'',
	            cp_teachers:'',
	            teacher:'',
	            pickerOptions0: {
	                disabledDate(time) {
	                    return time.getTime() < Date.now() - 8.64e7;
	                }
	            },
                catalogs1: [
                    {
                        "timeName": "08:30-09:00",
                        "select": 15,
                        "state":true
                    },
                    {
                        "timeName": "09:00-09:30",
                        "select": 1,
                        "state":true
                    },
                    {
                        "timeName": "09:30-10:00",
                        "select": 2,
                        "state": true
                    },
                    {
                        "timeName": "10:00-10:30",
                        "select":3,
                        "state": true
                    },
                    {
                        "timeName": "10:30-11:00",
                        "select": 4,
                        "state": true
                    },
                    {
                        "timeName": "11:00-11:30",
                        "select": 5,
                        "state": true
                    },
                    {
                        "timeName": "11:30-12:00",
                        "select": 6,
                        "state": true
                    },
                    {
                        "timeName": "12:00-12:30",
                        "select": 16,
                        "state": true
                    },
                ],
                catalogs2:[
                    {
                        "timeName": "13:30-14:00",
                        "select": 7,
                        "state": true
                    },
                    {
                        "timeName": "14:00-14:30",
                        "select": 8,
                        "state": true
                    },
                    {
                        "timeName": "14:30-15:00",
                        "select": 9,
                        "state": true
                    },
                    {
                        "timeName": "15:00-15:30",
                        "select": 10,
                        "state": true
                    },
                    {
                        "timeName": "15:30-16:00",
                        "select": 11,
                        "state": true
                    },
                    {
                        "timeName": "16:00-16:30",
                        "select": 12,
                        "state": true
                    },
                    {
                        "timeName": "16:30-17:00",
                        "select": 13,
                        "state": true
                    },
                    {
                        "timeName": "17:00-17:30",
                        "select": 14,
                        "state": true
                    },
                    {
                        "timeName": "17:30-18:00",
                        "select": 17,
                        "state": true
                    },
                    {
                        "timeName": "18:00-18:30",
                        "select": 18,
                        "state": true
                    },
                    {
                        "timeName": "18:30-19:00",
                        "select": 19,
                        "state": true
                    },
                    {
                        "timeName": "19:00-19:30",
                        "select": 20,
                        "state": true
                    },
                    {
                        "timeName": "19:30-20:00",
                        "select": 21,
                        "state": true
                    },
                    {
                        "timeName": "20:00-20:30",
                        "select": 22,
                        "state": true
                    },
                    {
                        "timeName": "20:30-21:00",
                        "select": 23,
                        "state": true
                    },

                ],
                catalogSelect: "",//判断是否选中
                timeslot:'',//时间段
			}
		},
		created() {
//
            this.centre_id=$.cookie("centre_id")
            this.create_user=$.cookie("create_user");
            this.token=$.cookie("token");
        },
		methods:{
            dateChange: function (time) {
                if (time) {
                    var date = new Date(Date.parse(time));
                    var newDate = date.getFullYear() + "-" + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + "-" + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
                    return newDate ;
                }
            },
            //点击时间段
            click_time:function(index,state){
                let self=this
                this.catalogSelect=index
                if(state==false){
                    alert("该时间段已满")
                    self.timeslot=""
                }else{
                    self.timeslot=index
                }
            },
            //触发获取时间段状态
            trigger1(){
                let self=this;
                if(self.cp_time&&self.teacher){
                    var  cp_time = self.dateChange(self.cp_time)
                    $.ajax({
                        url:process.env.apiUrl + 'saas/ceping/check_specific_time',
                        type:"post",
                        dataType:"json",
                        data:{
                            token:self.token,
                            cp_time:cp_time,
                            centre_id:self.user_id,
                            teacher:self.teacher,
                        },
                        success:function(data){
                            //console.log(data)
                            self.catalogs1=data.up,
                                self.catalogs2=data.down,
                                self.timeslot = '',
                                self.catalogSelect=''
                        }
                    });
                }
            },
            yuyue:function(){
                let self = this;
                if(self.cp_time==""||self.cp_time==null){
                    alert("请选择日期！")
                    return
                }
                if(self.teacher==""){
                    alert("请选择测评师！")
                    return
                }
                if(self.timeslot==""){
                    alert("请选择测评时间！")
                    return
                }
                self.cp_time = self.dateChange(self.cp_time);

                $.ajax({
                    url:process.env.apiUrl + `saas/ceping/yx_yuyue`,
                    type:"post",
                    dataType:"json",
                    data:{
                        user_id:self.user_id,
                        cp_time:self.cp_time,
                        teacher:self.teacher,
                        specific_time:self.timeslot,
                        token:self.token
                    },
                    success:function(data){
                        if(data.status == 1){
                            self.$message({
                                message: data.msg,
                                type: 'success',
                                duration:1000
                            });
                            setTimeout(function () {
                               self.$router.push({
                                   'name':'yinxiaolie'
							   })
                            },1000)
                        }else{
                            self.$message({
                                message: data.msg,
                                type: 'error',
                                duration:1000
                            });
                        }
                    }
                });
            },
            motai:function (userid) {
                let  self = this;
                self.user_id = userid;
                $("#myModal").modal();
            },
            jiansuo:function () {
                let self=this;
                if(self.cha == ''){
                    $('#suosuok').hide();
                }else{
                    $.ajax({
                        url:process.env.apiUrl + `saas/ceping/search`,
                        type:"post",
                        dataType:"json",
                        data:{
                            token:self.token,
                            username:self.cha
                        },
                        success:function(data){
                            self.ul_list = data;
                        }
                    });
                    $('#suosuok').show();
                }

            },
            searchinfo:function (uid,n) {
                let self=this;
				self.cha = n
                $.ajax({
                    url:process.env.apiUrl + `saas/ceping/searchinfo`,
                    type:"post",
                    dataType:"json",
                    data:{
                        user_id:uid,
                        token:self.token
                    },
                    success:function(data){
                        $('#suosuok').hide();
                        self.list=data.list;
                        self.cp_teachers = data.cp_teachers;
                    }
                });
            },
        },
	}
</script>

<style scoped="scoped">
	/*公用样式*/
	a{text-decoration: none;}
	ul{list-style:none;margin: 0;padding: 0;}
	em,
	i{font-style: normal;font-weight: normal;}
	img {vertical-align: top;border: 0;margin:0;padding:0;}
	h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {font-weight: 500;margin:0;padding:0;}
	*{margin: 0;padding:0;}
	input,a{outline:none;}
	.wrap {min-width: 320px; max-width: 640px; margin: 0 auto;}
	.fl{float:left;}
	.fr{float:right;}
	/*伪类清除浮动*/
	.fix{*zoom:1;}
	.fix:after{display:block; content:"clear"; height:0; clear:both; overflow:hidden; visibility:hidden;}

	/*重置bootstrap样式*/
	.has-feedback .form-control{
		padding-left: 20px;
	}

	.modal{
		position:relative;
	}
	.modal-content{
		padding: 10px 15px;
		box-sizing: border-box;
	}
	.modal-body{
		padding: 10px 15px;
	}
	.btn-primary{
		padding: 0 4px;
    	margin-top: 6px;
	}
	#suosuok{
		display: none;
	}


	[v-cloak] {
        display: none;
    }

    .yuyuelie .content{
        background: #fff;
        padding: 20px;
		height: 100%;
		box-sizing: border-box;
        border-radius: 10px;

    }
    .header{
        padding-bottom: 20px;
    }
    .huiBtn{
        padding:3px 20px;
        border-radius:18px;
        cursor: pointer;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        text-align: center;
        font-size: 16px;
    }
    .huiBtn.zi{
        background:#E6BE8A;
        color:#fff;
    }
    .huiBtn.bai{
       border: 1px solid #E6BE8A;
    }
    .fL{
        float: left;
    }
    .fR{
        float: right;
    }
    .marl20{
        margin-left: 20px;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #E6BE8A;
        color: #fff;
    }

	.box{
		width:270px;
		height: 70vh;
		overflow-y: scroll;
		background: #fff;
		border: 1px solid gainsboro;
	}
    .clearfloat:after{display:block;clear:both;content:"";visibility:hidden;height:0}
    .clearfloat{
		zoom:1;
		margin-top: 5px;
	}
    .clearfloat:hover{
		background-color: gainsboro;
	}
    .dam{
        display: block;
        float: left;
        width: 50%;
        overflow: hidden;
        text-align: center;
        padding: 2px 0;
    }






























    .chosetime{
        display: inline-block;
        width: 89px;
        border-radius:5px;
        border: 1px solid #E6BE8A;
        padding:5px;
        margin:5px;
        cursor:pointer;
    }
    .active{
        background: #E6BE8A;
    }
    .hui{
        border: 1px solid  #E6BE8A;
        background: #D0D0D0
    }
</style>



// WEBPACK FOOTER //
// src/pages/ceping/yuyuelie.vue